export default "__VITE_ASSET__CMTgONm7__"